<template>
  <div class="gallery-images">
    <div v-for="(image, i) in images" :key="`image-${i}`">
      <div
        v-if="image"
        :style="{ backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center'}"
        class="placeholder-pic border-black"
        @click="openImage(image)"
      >
      </div>
    </div>

    <v-dialog
      v-model="showImageDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="full-image-dialog">
        <img :src="imageToShow" width="300">
        <v-btn class="menu-button main-small" @click="imageToShow = null; showImageDialog = false">Schließen</v-btn>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'gallery-preview',

  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      showImageDialog: false,
      imageToShow: null,
    };
  },

  methods: {
    openImage(url) {
      this.imageToShow = url;
      this.showImageDialog = true;
    },
  },
};
</script>
